// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomDateRangePicker_wrapper__Bfdr-","customDay":"CustomDateRangePicker_customDay__YidHk"};